import React from "react";
import { Box, Typography } from "@mui/material";
import AccountInfo from "./AccountInfo";

interface TitleBarProps {
  title: string;
}

const TitleBar: React.FC<TitleBarProps> = ({ title }) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        position: "sticky",
        top: 0,
        pb: 4,
        zIndex: 2, // タイトルバーのzIndexを2に設定
        display: "flex",
        alignItems: "center",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        justifyContent: "space-between",
      }}
    >
      <AccountInfo />
      <Typography
        variant="h4"
        sx={{
          position: "absolute",
          left: "50%",
          pt: 9,
          transform: "translateX(-50%)",
          fontWeight: "bold",
          fontSize: "1.4rem",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default TitleBar;
